import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { StyledMain } from "../../styled/StyledMain";
import { MainContainer } from "../../styled/StyledMainContainer";

import { GuestCountContainer, StyledContainer } from "./styled/Container";
import {
  SearchInput,
  Table,
  Th,
  Td,
  DownloadContainer,
  PLACEHOLDER,
} from "./styled/Table";

import { convertArrayToCSV, downloadCSV } from "../../utils/utils";
import downloadIcon from "./img/download.svg";

import Spinner from "../../components/Spinner";
import { decodeJwt } from "../../utils/cryptography";
import NavBarComponent from "../campaign-manager/components/NavBar";
import {
  checkIn,
  checkOut,
  getGuestsForEventAction,
} from "../../features/event-manager/eventManagerSlice";
import GuestTrackerProtectedRoute from "../../components/GuestTrackerProtectedRoute";
import { useSearchParams } from "react-router-dom";

const GuestTracker = () => {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const event = searchParams.get("event");

  const { guests, fetchingGuests, errorFetchingGuests } = useSelector(
    (state) => state.events
  );

  useEffect(() => {
    dispatch(getGuestsForEventAction(event));
  }, [dispatch, event]);

  const [searchTerms, setSearchTerms] = useState({
    guestId: "",
    guestFirstName: "",
    guestLastName: "",
    guestGroup: "",
  });

  const handleSearch = (e) => {
    const { name, value } = e.target;
    setSearchTerms((prev) => ({ ...prev, [name]: value }));
  };

  const filteredData = guests.filter((guest) => {
    const { guestId, guestFirstName, guestLastName, guestGroup } = searchTerms;

    const match = (field, term) => {
      if (!term) return true;
      field = field?.toLowerCase() || "";
      term = term.toLowerCase();
      return field.includes(term);
    };

    return (
      match(guest.guestId, guestId) &&
      match(guest.guestFirstName, guestFirstName) &&
      match(guest.guestLastName, guestLastName) &&
      match(guest.guestGroup, guestGroup)
    );
  });

  const handleExport = (data, filename) => {
    const csvContent = convertArrayToCSV(data);
    downloadCSV(csvContent, filename);
  };

  function formatDateTime(isoString) {
    const date = new Date(isoString);

    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");

    return `${day}/${month}/${year} ${hours}:${minutes}`;
  }

  if (fetchingGuests) return <Spinner />;

  return (
    <StyledMain grayBg>
      <GuestTrackerProtectedRoute />
      <NavBarComponent />
      <MainContainer>
        <StyledContainer>
          <h2>Guest Tracker</h2>
          <div>
            <DownloadContainer>
              <GuestCountContainer>
                <p>{filteredData.length} Guest(s) found</p>
                <p>
                  {filteredData.filter((guest) => guest.checkedIn).length}{" "}
                  Guest(s) checked in
                </p>
              </GuestCountContainer>
              <img
                src={downloadIcon}
                alt="download"
                onClick={() =>
                  handleExport(
                    filteredData.map((guest) => ({
                      firstName: guest.guestFirstName || "",
                      lastName: guest.guestLastName || "",
                      group: guest.guestGroup || "",
                      message: guest.guestSlogan || "",
                      checkedInAt: guest.checkedIn ? guest.checkedInAt : "",
                    })),
                    "guests.csv"
                  )
                }
              />
            </DownloadContainer>
            <Table>
              <thead>
                <tr>
                  <Th></Th>
                  <Th>Name</Th>
                  <Th>Message</Th>
                  <Th>Checked In At</Th>
                  <Th></Th>
                </tr>
                <tr>
                  <Td></Td>
                  <Td>
                    <SearchInput
                      type="text"
                      name="guestFirstName"
                      placeholder="Search Name"
                      value={searchTerms.guestFirstName}
                      onChange={handleSearch}
                    />
                  </Td>

                  <Td></Td>
                  <Td></Td>
                  <Td></Td>
                </tr>
              </thead>
              <tbody>
                {[...filteredData]
                  .sort((a, b) =>
                    a.guestFirstName.localeCompare(
                      b.guestFirstName,
                      undefined,
                      {
                        sensitivity: "base",
                      }
                    )
                  )
                  .map((guest) => (
                    <tr key={guest.guestId}>
                      <Td>
                        <img
                          src={guest.guestPhotoURL ?? PLACEHOLDER}
                          alt="logo"
                          style={{
                            maxWidth: "40px",
                            maxHeight: "40px",
                            objectFit: "contain",
                          }}
                        />
                      </Td>

                      <Td>
                        <>{guest?.guestFirstName} </>
                      </Td>
                      <Td>
                        <>{guest?.guestSlogan} </>
                      </Td>
                      <Td>
                        {guest?.checkedIn
                          ? formatDateTime(guest.checkedInAt)
                          : ""}
                      </Td>
                      <Td>
                        {guest?.checkedIn ? (
                          <button
                            onClick={() =>
                              dispatch(
                                checkOut({
                                  guestId: guest.guestId,
                                  eventId: event,
                                })
                              )
                            }
                          >
                            Reset
                          </button>
                        ) : (
                          <button
                            onClick={() =>
                              dispatch(
                                checkIn({
                                  guestId: guest.guestId,
                                  eventId: event,
                                })
                              )
                            }
                          >
                            Check-In
                          </button>
                        )}
                      </Td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </div>
        </StyledContainer>
      </MainContainer>
    </StyledMain>
  );
};

export default GuestTracker;
